'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_mz469_1";
const closeButton = "_close-button_mz469_24";
const styles = {
	root: root,
	closeButton: closeButton
};

const ModalMediaContent = (props) => {
  return React__default.default.createElement(
    "div",
    { className: styles.root, "data-zds": true },
    props.children,
    props.closeButton && React__default.default.createElement("div", { className: styles.closeButton, "data-zds": true }, props.closeButton)
  );
};

exports.ModalMediaContent = ModalMediaContent;
//# sourceMappingURL=ModalMediaContent.cjs.js.map
